import { IChangeTrackingFacade, IEntity, SafeAny } from '@pf/shared-common';
import { Injectable, NgModuleRef, inject } from '@angular/core';

import { EntityHistoryDrawerComponent } from '../..';
import { InjectionService } from '@pf/shared-ui';
import { first } from 'rxjs';

@Injectable()
export class EntityHistoryService {
    private injectionService = inject(InjectionService);
    private moduleRef = inject<NgModuleRef<SafeAny>>(NgModuleRef);

    create(entityName: string, facade: IChangeTrackingFacade<IEntity>) {
        const componentRef = this.injectionService.appendComponentHost({
            component: EntityHistoryDrawerComponent,
            hostLocation: 'root',
            ngModuleRef: this.moduleRef,
            props: {
                entityName,
                facade,
            },
        });
        componentRef.instance.closed$
            .pipe(first())
            .subscribe(() => componentRef.destroy());
        return componentRef.instance;
    }
}
